import React from "react";
import { ProductivityServiceTemplate } from "../../Templates/ProductivityServiceTemplate";

export const ProductivityService = () => {
  return <ProductivityServiceTemplate />;
};
